module.exports = __webpack_public_path__ + "static/media/176971A.8d98fe36.jpg";